import React from 'react';
import i18n from 'i18next';
import { BodyText } from '@gaiads/telia-react-component-library';
import { SalesChannel } from '@cdaas/api-clients/dist/product-service-openapi';

//TODO: rename id to UUID when tranformation from id to UUID is clear for all cases
const SalesChannelInfo = ({
  variantSalesChannelUuids,
  allSalesChannels,
}: {
  variantSalesChannelUuids?: string[];
  allSalesChannels: SalesChannel[];
}) => {
  if (!Array.isArray(variantSalesChannelUuids) || allSalesChannels.length === 0) {
    return null;
  }

  const productSalesChannelsTexts = variantSalesChannelUuids
    .map((uuid: string) => {
      return allSalesChannels.find((salesChannel: SalesChannel) => salesChannel.uuid === uuid)?.name;
    })
    .filter(name => name);

  const [first] = productSalesChannelsTexts;

  if (productSalesChannelsTexts.length > 1) {
    const leftCount = productSalesChannelsTexts.length - 1;
    return (
      <BodyText>
        {i18n.t('productsscreen:productsTable.salesChannelAndMore', {
          salesChannel: first,
          leftCount: leftCount,
          interpolation: {
            escapeValue: false,
          },
        })}
      </BodyText>
    );
  }
  return <BodyText>{first}</BodyText>;
};

export default SalesChannelInfo;
